import React, { useEffect, useState } from 'react';

const LoginRedirect: React.FC = () => {
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const checkLoopAndRedirect = () => {
            // --- SAFEGUARD LOGIC ---
            const MAX_RETRIES = 2;
            const RESET_TIME_MS = 10000; // 10 seconds
            const now = Date.now();

            // 1. Retrieve tracking data
            const storedCount = sessionStorage.getItem('login_redirect_count');
            const storedTime = sessionStorage.getItem('login_redirect_timestamp');

            let count = storedCount ? parseInt(storedCount, 10) : 0;
            const lastTime = storedTime ? parseInt(storedTime, 10) : 0;

            // 2. Reset count if the last redirect was a while ago
            // (This allows the user to log in normally later without getting blocked)
            if (now - lastTime > RESET_TIME_MS) {
                count = 0;
            }

            // 3. Check if we have exceeded the limit
            if (count >= MAX_RETRIES) {
                setError(
                    'Login Loop Detected. Please ensure your browser accepts cookies from paradigmmath.com or try clearing your cache.'
                );

                // Clear the count so they aren't blocked forever if they refresh manually
                sessionStorage.removeItem('login_redirect_count');
                return; // STOP execution here
            }

            // 4. Increment and Save
            sessionStorage.setItem('login_redirect_count', (count + 1).toString());
            sessionStorage.setItem('login_redirect_timestamp', now.toString());

            // --- REDIRECT LOGIC ---
            const isLocal = window.location.hostname === 'localhost';

            // Define the Classroom App URL
            const classroomBaseUrl = isLocal
                ? 'http://localhost:5173'
                : 'https://classroom.paradigmmath.com';

            // Execute Redirect
            window.location.href = `${classroomBaseUrl}/login?redirect=teacher`;
        };

        checkLoopAndRedirect();
    }, []);

    // Render Error UI if loop detected
    if (error) {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginTop: '100px',
                    padding: '20px',
                    textAlign: 'center',
                }}
            >
                <h2 style={{ color: '#d9534f' }}>Unable to Log In</h2>
                <p style={{ maxWidth: '400px', margin: '20px 0' }}>{error}</p>
                <button
                    onClick={() => window.location.reload()}
                    style={{
                        padding: '10px 20px',
                        cursor: 'pointer',
                        background: '#0275d8',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                    }}
                >
                    Try Again
                </button>
            </div>
        );
    }

    // Render Loading UI
    return (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
            <p>Redirecting to Paradigm Classroom...</p>
        </div>
    );
};

export default LoginRedirect;
